<template>
  <div id="body">
    <base-navigation></base-navigation>

    <base-card>
      <div id="element-to-convert">
        <div class="row">
          <div class="col-lg-6">
            <img width="120" height="100" src="../../assets/twiga_logo.png" />
          </div>

          <div class="col-lg-6">
            <small> Twiga court Residents association </small>
            <br />
            <small> 2026 Membership security and development payments </small>
            <br />
            <p class="text-primary">
              Make payment to mpesa paybill <strong>542542</strong> account
              <strong>38458</strong>
            </p>

            <!-- details {{ memberdetails }} -->

            <!-- expenses {{ expenses }} -->
            <!-- <br />
      <small>  Itibo, Nyamira county </small> 
          <br />
      <small>  itibo.roberms.com, itibowelfare@gmail.com </small>  -->

            <!-- {{ memberdetails }} -->
          </div>
        </div>

        <div class="row">
          <div class="col-lg-7">
            <small>Membership Report</small>

            <!-- project {{ project_amount }} -->
            <!-- detail {{ memberdetails }} -->
          </div>
          <div class="col-lg-5 text-info">
            Date
            <small> {{ Date().toLocaleString("nl-NL").split("GMT")[0] }}</small>
          </div>
        </div>

        <br />

        <!-- payments {{ this.$store.getters.joiningMember(2) }} -->

        <table class="table myFormat table-striped table-bordered table-sm">
          <thead>
  <tr>
    <th rowspan="2">No.</th>
    <th rowspan="2">Name</th>
    <th rowspan="2"><small>2025 Bal</small></th>

    <th colspan="3">Quarter 1</th>
    <th colspan="3">Quarter 2</th>
    <th colspan="3">Quarter 3</th>
    <th colspan="3">Quarter 4</th>

    <th class="small" rowspan="2">Total Security</th>
    <th class="small" rowspan="2">Total Development</th>
        <th class="small" rowspan="2">Project Amount</th>

  </tr>

  <tr>
    <!-- Q1 -->
    <th><small>Jan</small></th>
    <th><small>Feb</small></th>
    <th><small>Mar</small></th>

    <!-- Q2 -->
    <th><small>Apr</small></th>
    <th><small>May</small></th>
    <th><small>Jun</small></th>

    <!-- Q3 -->
    <th><small>Jul</small></th>
    <th><small>Aug</small></th>
    <th><small>Sep</small></th>

    <!-- Q4 -->
    <th><small>Oct</small></th>
    <th><small>Nov</small></th>
    <th><small>Dec</small></th>
  </tr>
</thead>

          <tbody>
            <tr v-for="(member, index) in memberdetails" :key="member.id">
              <td>
                <small>{{ index + 1 }}</small>
              </td>
              <td>
                <small>{{ member.member_name }}</small>
              </td>

              <td class="font-weight-bold">
                <small>{{ member.previous_balance }}</small>
              </td>
              
              <td>
                <small>{{ member.Jan }}</small>
              </td>
              <td>
                <small>{{ member.Feb }}</small>
              </td>
              <td>
                <small>{{ member.March }}</small>
              </td>
              <td>
                <small>{{ member.April }}</small>
              </td>
              <td>
                <small>{{ member.May }}</small>
              </td>
              <td>
                <small>{{ member.June }}</small>
              </td>
              <td>
                <small>{{ member.July }}</small>
              </td>
              <td>
                <small>{{ member.August }}</small>
              </td>
              <td>
                <small>{{ member.September }}</small>
              </td>
              <td>
                <small>{{ member.October }}</small>
              </td>
              <td>
                <small>{{ member.November }}</small>
              </td>
              <td>
                <small>{{ member.December }}</small>
              </td>

              <!-- Total Security -->
              <td class="font-weight-bold">
                {{
                  (
                    parseInt(member.Jan || 0, 10) +
                    parseInt(member.Feb || 0, 10) +
                    parseInt(member.March || 0, 10) +
                    parseInt(member.April || 0, 10) +
                    parseInt(member.May || 0, 10) +
                    parseInt(member.June || 0, 10) +
                    parseInt(member.July || 0, 10) +
                    parseInt(member.August || 0, 10) +
                    parseInt(member.September || 0, 10) +
                    parseInt(member.October || 0, 10) +
                    parseInt(member.November || 0, 10) +
                    parseInt(member.December || 0, 10)
                  ).toLocaleString()
                }}
              </td>

              <!-- Total Development -->
              <td class="font-weight-bold">
                {{ member.Development_amount }}
              </td>

                <!-- projectr  -->
              <td class="font-weight-bold text-primary">
                {{ member.Project_amount }}
              </td>
            </tr>

            <!-- TOTAL ROW -->
            <tr class="table-warning font-weight-bold">
              <td colspan="2" class="text-center">TOTAL</td>
              <td>{{ (getTotal("previous_balance")).toLocaleString()  }}</td>
                            <td>{{ (getTotal("Jan")).toLocaleString()  }}</td>

              <td>{{ (getTotal("Feb")).toLocaleString()  }}</td>
              <td>{{ (getTotal("March")).toLocaleString()  }}</td>
              <td>{{ (getTotal("April")).toLocaleString()  }}</td>
              <td>{{ (getTotal("May")).toLocaleString()  }}</td>
              <td>{{ (getTotal("June")).toLocaleString()  }}</td>
              <td>{{ (getTotal("July")).toLocaleString()  }}</td>
              <td>{{ (getTotal("August")).toLocaleString()  }}</td>
              <td>{{ (getTotal("September")).toLocaleString()  }}</td>
              <td>{{ (getTotal("October")).toLocaleString()  }}</td>
              <td>{{ (getTotal("November")).toLocaleString()  }}</td>
              <td>{{ (getTotal("December")).toLocaleString()  }}</td>

              <!-- Grand Total Security -->
              <td>{{ (getTotalSecurity()).toLocaleString()  }}</td>

              <!-- Grand Total Development -->
              <td>{{ (getTotalDevelopment()).toLocaleString() }}</td>
                 <td class="text-primary">{{ (getTotalProject()).toLocaleString() }}</td>
            </tr>
          </tbody>
        </table>

        <br />
        <br />

        <!-- expenses -->

        <div class="row">
          <br />
          <br />

          <!-- <div class="col">
            <table class="table myFormat table-striped table-bordered table-sm">
              <thead>
                <tr>
                  <th><small>Item.</small></th>
                  <th><small>Description</small></th>
                  <th><small>Amount</small></th>
                  <th><small>Category</small></th>
                  <th><small>Date</small></th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="expense in expenses" :key="expense.id">
                  <td>
                    <small> {{ expense.item }}</small>
                  </td>
                  <td>
                    <small>{{ expense.description }}</small>
                  </td>

                  <td>
                    <small>{{ expense.amount }}</small>
                  </td>

                  <td>
                    <small>{{ expense.category }}</small>
                  </td>
                  <td>
                    <small>{{ expense.expense_date.split("T")[0] }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </div>

      <br />

      <div class="export-buttons">
  <button class="btn pdf" @click="exportToPDF">
    📄 PDF
  </button>

  <button class="btn jpeg" @click="downloadJPEG">
    🖼️ JPEG
  </button>

  <button class="btn csv" @click="downloadCsv">
    📊 CSV
  </button>
</div>


      <!-- <button @click="exportToPDF">Download</button> -->
      <br />
      <router-link to="/">Go back</router-link>
    </base-card>
  </div>
</template>
<script>
//   import axios from "axios";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";

export default {
  methods: {
    exportToPDF() {
      var element = document.getElementById("element-to-convert");
      html2pdf(element, {
        margin: [0, 10, 0, 10], //top, left, buttom, right
        filename:
          "Twiga court report as at " +
          new Date(Date.now()).toLocaleString("nl-NL").split(",")[0] +
          ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          scale: 2,
          logging: true,
          letterRendering: true,
        },
        jsPDF: { unit: "mm", format: [280, 550], orientation: "portrait" },
      });
    },

downloadJPEG() {
  const element = document.getElementById("element-to-convert");

  if (!element) {
    alert("No content found");
    return;
  }

  html2canvas(element).then(canvas => {
    const link = document.createElement("a");
    link.download = "Twiga court report as at " +
          new Date(Date.now()).toLocaleString("nl-NL").split(",")[0] +
          ".jpg",
    link.href = canvas.toDataURL("image/jpeg", 0.5);
    link.click();
  });
},
downloadCsv() {
  const element = document.getElementById("element-to-convert");

  if (!element) {
    alert("Table not found");
    return;
  }

  const table = element.querySelector("table");

  if (!table) {
    alert("No table inside element");
    return;
  }

  let csv = [];

  // 🔹 Get all rows
  const rows = table.querySelectorAll("tr");

  rows.forEach(row => {
    const cols = row.querySelectorAll("th, td");

    const rowData = Array.from(cols).map(col => {
      let text = col.innerText.trim();

      // Escape quotes
      text = text.replace(/"/g, '""');

      return `"${text}"`;
    });

    csv.push(rowData.join(","));
  });

  const csvContent = csv.join("\n");

  // ✅ Download
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;"
  });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = "Twiga court report as at " +
          new Date(Date.now()).toLocaleString("nl-NL").split(",")[0] +
          ".csv",

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
  },

  computed: {
    memberdetails() {
      return this.$store.getters.allMembers;
    },

    getTotal() {
      return (month) => {
        return this.memberdetails.reduce(
          (sum, member) => sum + parseInt(member[month] || 0, 10),
          0
        );
      };
    },
    getTotalSecurity() {
      return () => {
        return this.memberdetails.reduce(
          (sum, member) =>
            sum +
            (parseInt(member.Jan || 0, 10) +
              parseInt(member.Feb || 0, 10) +
              parseInt(member.March || 0, 10) +
              parseInt(member.April || 0, 10) +
              parseInt(member.May || 0, 10) +
              parseInt(member.June || 0, 10) +
              parseInt(member.July || 0, 10) +
              parseInt(member.August || 0, 10) +
              parseInt(member.September || 0, 10) +
              parseInt(member.October || 0, 10) +
              parseInt(member.November || 0, 10) +
              parseInt(member.December || 0, 10)),
          0
        );
      };
    },
    getTotalDevelopment() {
      return () => {
        return this.memberdetails.reduce(
          (sum, member) => sum + parseInt(member.Development_amount || 0, 10),
          0
        );
      };
    },

     getTotalProject() {
      return () => {
        return this.memberdetails.reduce(
          (sum, member) => sum + parseInt(member.Project_amount || 0, 10),
          0
        );
      };
    },

    // memberdetails(){

    //  return  this.$store.getters.newmembers
    // },
    membercases() {
      return this.$store.getters.allcases;
    },
    payments() {
      return this.$store.getters.allPayments;
    },

  

    memberPayments() {
      return this.$store.getters.payments; //.filter((col) => col.member_id == memberId)
    },
   
 
    previous_balance() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.previous_balance),
        0
      );
    },
    
    jan_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.Jan),
        0
      );
    },
    feb_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.Feb),
        0
      );
    },
    march_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.March),
        0
      );
    },
    
    april_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.April),
        0
      );
    },
    may_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.May),
        0
      );
    },
    june_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.June),
        0
      );
    },
    july_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.July),
        0
      );
    },
    august_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.August),
        0
      );
    },

    september_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.September),
        0
      );
    },
    october_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.October),
        0
      );
    },

    november_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.November),
        0
      );
    },

    december_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.December),
        0
      );
    },

    wallet_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.wallet_amount),
        0
      );
    },

    development_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.development_amount),
        0
      );
    },

    project_amount() {
      return this.memberdetails.reduce(
        (acc, item) => acc + parseInt(item.Project_amount),
        0
      );
    },

    expenses() {
      return this.$store.getters.expenses;
    },
    total_expense() {
      return this.expenses.reduce(
        (acc, item) => acc + parseInt(item.amount),
        0
      );
    },
  },
  created() {
    this.$store.dispatch("LoadMembers");
    // this.$store.dispatch("LoadPayments");
    // this.$store.dispatch("LoadNewmembers");
    // this.$store.dispatch("LoadCases");
    this.$store.dispatch("LoadExpenses");
  },
};
</script>

<style scoped>
table.myFormat tr td {
  font-size: 12px;
}
.export-buttons {
  display: flex;
  width: 100%;
  gap: 10px;
}

.btn {
  flex: 1; /* 🔥 makes all buttons equal width */
  padding: 14px;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
  font-size: 15px;
}

/* Colors */
.btn.pdf {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
}

.btn.jpeg {
  background: linear-gradient(135deg, #8e44ad, #6c3483);
}

.btn.csv {
  background: linear-gradient(135deg, #27ae60, #1e8449);
}

/* Hover effect */
.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0,0,0,0.2);
}
</style>
